// src/landing_page/TestimonialCarousel.js
import React, { useState, useEffect } from 'react';
import './Testimonials.css'; // Make sure your CSS has the .fade-out class

const TestimonialCarousel = () => {
    const [currentTestimonial, setCurrentTestimonial] = useState(null); // Holds the currently displayed testimonial
    const [nextTestimonial, setNextTestimonial] = useState(null);     
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isFadingOut, setIsFadingOut] = useState(false);

    useEffect(() => {
        const fetchTestimonial = async () => {
            setIsFadingOut(true); 

            try {
                // Fetch data from the API endpoint (prod)
                ///const response = await fetch('/api/get_user_testimonials');
                // Fetch data from the API endpoint (dev)
                const response = await fetch('/api/get_user_testimonials');
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.json();
                setNextTestimonial(data[0]); 

            } catch (error) {
                setError(error.message);
                setIsFadingOut(false); 
            }
        };

        // Initial fetch 
        if (currentTestimonial === null) {
             fetchTestimonial();
        }

        const intervalId = setInterval(fetchTestimonial, 5000);
        return () => clearInterval(intervalId);
    }, []);

    // Runs when next testimonial is changes/set
    useEffect(() => {
        if (nextTestimonial) {  
            setTimeout(() => {
              setCurrentTestimonial(nextTestimonial); 
              setNextTestimonial(null);            
              setIsFadingOut(false);               
              setLoading(false);
            }, 500);
        }
    }, [nextTestimonial]); 

    if (loading && !currentTestimonial) {
       return <div className="testimonial-carousel">Loading...</div>;
    }
    if (error) {
        return <div className="testimonial-carousel">Error: {error}</div>;
    }

    // No need to check for null currentTestimonial, as we initialize it to null
     if (!currentTestimonial) {
          return <div className="testimonial-carousel">No testimonials found.</div>;
        }


    return (
        <div className="testimonial-carousel">
            <div className={`testimonial-card ${isFadingOut ? 'fade-out' : ''}`} key={currentTestimonial.testimonial_id}>
                <p className="testimonial-text">"{currentTestimonial.testimonial}"</p>
                <p className="testimonial-author">- {currentTestimonial.user_name || 'Anonymous'}</p>
            </div>
        </div>
    );
};

export default TestimonialCarousel;